import React from 'react';

const AuctionCoreContext = React.createContext(null);

export const withAuctionCore = (Component) => (props) => (
  <AuctionCoreContext.Consumer>
    {(auctioncore) => <Component {...props} auctioncore={auctioncore} />}
  </AuctionCoreContext.Consumer>
);

export default AuctionCoreContext;
